import React from 'react';

export const EyePassword = ({ setEye, eye }) => {
  if (eye) {
    return (
      <svg
        role="img"
        onClick={() => setEye(!eye)}
        width="20"
        height="20"
        className="absolute cursor-pointer right-0 top-0 -translate-x-[50%] translate-y-[50%]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          {' '}
          <path
            d="M14.83 9.17999C14.2706 8.61995 13.5576 8.23846 12.7813 8.08386C12.0049 7.92926 11.2002 8.00851 10.4689 8.31152C9.73758 8.61453 9.11264 9.12769 8.67316 9.78607C8.23367 10.4444 7.99938 11.2184 8 12.01C7.99916 13.0663 8.41619 14.08 9.16004 14.83"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M12 16.01C13.0609 16.01 14.0783 15.5886 14.8284 14.8384C15.5786 14.0883 16 13.0709 16 12.01"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M17.61 6.39004L6.38 17.62C4.6208 15.9966 3.14099 14.0944 2 11.99C6.71 3.76002 12.44 1.89004 17.61 6.39004Z"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M20.9994 3L17.6094 6.39"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M6.38 17.62L3 21"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
          <path
            d="M19.5695 8.42999C20.4801 9.55186 21.2931 10.7496 21.9995 12.01C17.9995 19.01 13.2695 21.4 8.76953 19.23"
            stroke="#696969"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"></path>{' '}
        </g>
      </svg>
    );
  }
  return (
    <svg
      role="img"
      onClick={() => setEye(!eye)}
      className="absolute cursor-pointer right-0 top-0 -translate-x-[50%] translate-y-[50%]"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M12 16.01C14.2091 16.01 16 14.2191 16 12.01C16 9.80087 14.2091 8.01001 12 8.01001C9.79086 8.01001 8 9.80087 8 12.01C8 14.2191 9.79086 16.01 12 16.01Z"
          stroke="#696969"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M2 11.98C8.09 1.31996 15.91 1.32996 22 11.98"
          stroke="#696969"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M22 12.01C15.91 22.67 8.09 22.66 2 12.01"
          stroke="#696969"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
      </g>
    </svg>
  );
};
